import { render, staticRenderFns } from "./WeightLossInventoryMenu.vue?vue&type=template&id=5d41ea1c&scoped=true"
import script from "./WeightLossInventoryMenu.vue?vue&type=script&lang=js"
export * from "./WeightLossInventoryMenu.vue?vue&type=script&lang=js"
import style0 from "./WeightLossInventoryMenu.vue?vue&type=style&index=0&id=5d41ea1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d41ea1c",
  null
  
)

export default component.exports